<template>
    <div id="login-bg">
        <el-form :model="form" ref="form" label-width="60px" class="login-box" label-position="left">
            <h3>登录</h3>
            <el-form-item class="ef-item" label="账号">
                <el-input type="text" v-model="form.account"></el-input>
            </el-form-item>
            <el-form-item class="ef-item" label="密码">
                <el-input type="password" v-model="form.pwd" @keyup.enter.native="login(form)"></el-input>
            </el-form-item>
            <el-form-item label-width="0px">
                <el-button type="primary" @click="login(form)">登录</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                form: {
                    account: '',
                    pwd: '',
                },
                rules: {
                    account: {}
                }
            }
        },
        methods: {
            login(form) {
                window.console.log("------- form " + form);
                this.$api.account.login(form).then((data) => {
                    window.console.log("-------" + data);
                    if (data === "success") {
                        window.$cookies.set("token", data, "30min");
                        this.$router.push("/home");
                    }
                });
            }
        }
    }
</script>

<style>
    #login-bg {
        background: url("../assets/bg.png");
        height: 100%;
        background-size: cover;
    }

    h3 {
        color: white;
    }

    .login-box {
        background: #001529;
        width: 300px;
        height: 250px;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        border-radius: 5px;
        padding: 2px 30px;
        box-shadow: 0 0 20px 20px rgba(0, 0, 0, 0.6);
    }

    .ef-item .el-form-item__label {
        color: white;
        font-size: 18px;
    }
</style>